import { getBoardIntegrations } from "../services/apiBoards";
import { hasQueryValue, useMappedQuery } from "./queryUtils";

export function useBoardIntegrations(boardId, enabled = true) {
  return useMappedQuery({
    queryKey: ["boardIntegrations", boardId],
    queryFn: () => getBoardIntegrations(boardId),
    enabled: enabled && hasQueryValue(boardId),
    dataKey: "integrationsData",
  });
}
